import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Arrow, Switch } from "../FrameSwitcherControls";
import { debounce } from "../../../../utils/timed-functions";
import { getMobileOS } from "../../../../utils/detect-mobile";
import { arrowsDefaultProps, arrowsPropTypes, basicDefaultProps, basicPropTypes, opacityLayerDefaultProps, opacityLayerPropTypes, switchDefaultProps, switchPropTypes } from "./props";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/**
 * This component render view for FrameSwitcher and handle resize
 * @class
 * @augments React.PureComponent
 */
export var FrameSwitcherView = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FrameSwitcherView, _React$PureComponent);
  var _super = _createSuper(FrameSwitcherView);
  function FrameSwitcherView() {
    var _this;
    _classCallCheck(this, FrameSwitcherView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      activeFrame: 0
    });
    _defineProperty(_assertThisInitialized(_this), "bindConteinerReference", function (ref) {
      _this.container = ref;
      _this.handleResize();
    });
    _defineProperty(_assertThisInitialized(_this), "bindContentReference", function (ref) {
      _this.content = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "handleResize", debounce(function () {
      if (_this.props.onResize) {
        var _ref = _this.container || {},
          _ref$clientWidth = _ref.clientWidth,
          clientWidth = _ref$clientWidth === void 0 ? 0 : _ref$clientWidth,
          _ref$clientHeight = _ref.clientHeight,
          clientHeight = _ref$clientHeight === void 0 ? 0 : _ref$clientHeight;
        _this.scrollTo((_this.state.activeFrame + 1) * clientWidth);
        _this.props.onResize(clientWidth, clientHeight);
      }
    }, 100));
    _defineProperty(_assertThisInitialized(_this), "renderSwicth", function () {
      return _this.props.noSwitch ? null : /*#__PURE__*/React.createElement(Switch, {
        activeFrame: _this.state.activeFrame,
        className: _this.props.dotClass,
        onSwitch: _this.showSlide,
        totalFrames: _this.props.frames.length
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderOpacityLayer", function () {
      return _this.props.opacityLayer ? /*#__PURE__*/React.createElement("div", {
        className: cx('opacityLayer')
      }, (_this.props.cycle || _this.state.activeFrame !== 0) && /*#__PURE__*/React.createElement("div", {
        className: cx('opacityLayerLeft', _this.props.opacityLeftClass)
      }), (_this.props.cycle || _this.state.activeFrame !== _this.props.frames.length - 1) && /*#__PURE__*/React.createElement("div", {
        className: cx('opacityLayerRight', _this.props.opacityRightClass)
      })) : null;
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: cx('frameSwitcher', {
          draggable: _this.props.draggable,
          native: FrameSwitcherView.isNative
        }, _this.props.className),
        ref: _this.bindConteinerReference
      }, _this.renderOpacityLayer(), /*#__PURE__*/React.createElement("div", {
        className: cx('staticContent')
      }, _this.props.static), /*#__PURE__*/React.createElement("div", {
        className: cx('frames'),
        ref: _this.bindContentReference
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('placeholder'),
        style: {
          width: _this.props.placeholderWidth
        }
      }), _this.renderFrames(), /*#__PURE__*/React.createElement("div", {
        className: cx('placeholder'),
        style: {
          width: _this.props.placeholderWidth
        }
      })), _this.props.children, _this.renderSwicth(), _this.renderArrows());
    });
    return _this;
  }
  _createClass(FrameSwitcherView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      setTimeout(this.handleResize, 100);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "renderArrows",
    value: function renderArrows() {
      if (this.props.noArrows) {
        return null;
      }
      var maxFrame = this.props.frames.length - this.props.framesPerSlide;
      var isLeftActive = this.props.cycle || this.state.activeFrame > 0;
      var isRightActive = this.props.cycle || this.state.activeFrame < maxFrame;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('arrows')
      }, /*#__PURE__*/React.createElement(Arrow, {
        active: isLeftActive,
        className: this.props.arrowClass,
        direction: "left",
        key: "left",
        onClick: this.showLeft
      }), /*#__PURE__*/React.createElement(Arrow, {
        active: isRightActive,
        className: this.props.arrowClass,
        direction: "right",
        key: "right",
        onClick: this.showRight
      }));
    }
  }, {
    key: "renderFrames",
    value: function renderFrames() {
      var count = this.props.cycle ? this.props.framesPerSlide : 0;
      var _this$props = this.props,
        frameWidth = _this$props.frameWidth,
        gutter = _this$props.gutter;
      var frames = [].concat(_toConsumableArray(this.props.frames), _toConsumableArray(this.props.frames.slice(0, count)));
      return frames.map(function (frame, index) {
        return /*#__PURE__*/cloneElement(frame, {
          key: index,
          style: {
            width: frameWidth,
            marginLeft: index === 0 ? 0 : gutter / 2,
            marginRight: index === frames.length - 1 ? 0 : gutter / 2
          }
        });
      });
    }
  }]);
  return FrameSwitcherView;
}(React.PureComponent);
_defineProperty(FrameSwitcherView, "defaultProps", _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicDefaultProps), arrowsDefaultProps), switchDefaultProps), opacityLayerDefaultProps), {}, {
  placeholderWidth: 0
}));
_defineProperty(FrameSwitcherView, "isNative", !!getMobileOS());
_defineProperty(FrameSwitcherView, "placeholderWidth", 500);
FrameSwitcherView.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, basicPropTypes), arrowsPropTypes), switchPropTypes), opacityLayerPropTypes), {}, {
  placeholderWidth: PropTypes.number,
  frames: PropTypes.node.isRequired,
  static: PropTypes.node,
  children: PropTypes.node
}) : {};